// extracted by mini-css-extract-plugin
module.exports = {"layout":"EditModeDisclaimer_layout__10TVq","content":"EditModeDisclaimer_content__z3x-n","text":"EditModeDisclaimer_text__xARxH"};